@let projectedLocation = projectedLocation$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/property-search"></ion-back-button>
    </ion-buttons>
    <ion-title>Camera View</ion-title>
  </ion-toolbar>
</red-header-content>
<ion-content [scrollX]="false" [scrollY]="false">
  <div
    id="cameraPreview"
    class="tw:absolute tw:top-0 tw:left-0 tw:z-0 tw:flex tw:h-full tw:w-full tw:items-center tw:justify-center"
  ></div>

  @switch (canStartCamera) { @case (true) {
  <div
    [ngClass]="{ 'border-success': projectedLocation?.isAccuracyReady === true, 'border-warning': projectedLocation?.isAccuracyReady === false }"
    class="tw:absolute tw:top-6 tw:left-6 tw:z-10 tw:h-24 tw:w-24 tw:border-t-8 tw:border-l-8"
  ></div>
  <div
    [ngClass]="{ 'border-success': projectedLocation?.isAccuracyReady === true, 'border-warning': projectedLocation?.isAccuracyReady === false }"
    class="tw:absolute tw:top-6 tw:right-6 tw:z-10 tw:h-24 tw:w-24 tw:border-t-8 tw:border-r-8"
  ></div>
  @if (projectedLocation?.isAccuracyReady === false) {
  <div class="tw:absolute tw:bottom-1/2 tw:z-10 tw:flex tw:w-full tw:justify-center">
    <div class="background-warning tw:rounded-sm tw:p-2 tw:text-center">Searching... wait for green.</div>
  </div>
  }
  <div
    [ngClass]="{ 'border-success': projectedLocation?.isAccuracyReady === true, 'border-warning': projectedLocation?.isAccuracyReady === false }"
    class="tw:absolute tw:bottom-6 tw:left-6 tw:z-10 tw:h-24 tw:w-24 tw:border-b-8 tw:border-l-8"
  ></div>
  <div
    [ngClass]="{ 'border-success': projectedLocation?.isAccuracyReady === true, 'border-warning': projectedLocation?.isAccuracyReady === false }"
    class="tw:absolute tw:right-6 tw:bottom-6 tw:z-10 tw:h-24 tw:w-24 tw:border-r-8 tw:border-b-8"
  ></div>
  <ion-fab horizontal="center" vertical="bottom" slot="fixed">
    <ion-fab-button
      (click)="searchProfile()"
      [color]="projectedLocation?.isAccuracyReady? 'success' : 'warning'"
      [disabled]="projectedLocation?.isAccuracyReady === false"
      class="tw:mr-0"
    >
      <ion-icon name="camera-outline"></ion-icon>
    </ion-fab-button>
    <ng-content></ng-content>
  </ion-fab>
  @if ((debugMode$ | async)) {
  <div class="tw:absolute tw:h-full tw:w-full tw:bg-rose-800/60">
    <div class="tw:p-10 tw:font-bold tw:text-white tw:uppercase">
      <div class="tw:mt-10 tw:text-center">TERMINATOR VISION_</div>
      <div class="tw:mt-12">
        <div class="tw:text-center">COMPASS:</div>
        <div>Accuracy: {{projectedLocation?.compassAccuracy | redCompassAccuracy }}</div>
        <div>Heading: {{projectedLocation?.compassHeading?.toString() | redDashIfEmpty }}</div>
      </div>
      <div class="tw:mt-32">
        <div class="tw:text-center">GEOLOCATION:</div>
        <div>Accuracy: {{projectedLocation?.geolocationAccuracy?.toString() | redDashIfEmpty }}</div>
        <div>Longitude: {{projectedLocation?.geolocationPosition?.lng?.toString() | redDashIfEmpty }}</div>
        <div>Latitude: {{projectedLocation?.geolocationPosition?.lat?.toString() | redDashIfEmpty }}</div>
      </div>
      <div class="tw:mt-10">
        <div class="tw:text-center">PROJECTION:</div>
        <div>Longitude: {{projectedLocation?.projectedLocation?.lng?.toString() | redDashIfEmpty }}</div>
        <div>Latitude: {{projectedLocation?.projectedLocation?.lat?.toString() | redDashIfEmpty }}</div>
      </div>
    </div>
  </div>
  } } @case (false) {
  <div class="tw:absolute tw:top-0 tw:left-0 tw:h-full tw:w-full">
    <div class="tw:m-4 tw:text-xs">
      <ion-note color="medium">
        We where unable to access the camera for this feature. (Error: {{cameraStartError}})
      </ion-note>
    </div>
  </div>
  } }
</ion-content>
